import api from "./baseApi";
import endpoints from "./endpoints";

export const getTransactions = async ({
  page = 1,
  perPage = 10,
  sortBy = "createdAt",
  sortOrder = "DESC",
  filters = {}, // optional: for dynamic query filters
} = {}) => {
  try {
    const res = await api.get(endpoints.transactions.base, {
      params: {
        page,
        perPage,
        sortBy,
        sortOrder,
        ...filters, // spreads additional filters into query
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch transactions";

    throw new Error(message);
  }
};

export const getTransaction = async (id) => {
  try {
    const res = await api.get(endpoints.transactions.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch transaction";

    throw new Error(message);
  }
};

export const updateTransaction = async (id, payload) => {
  try {
    const res = await api.put(endpoints.transactions.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update transaction";

    throw new Error(message);
  }
};

export const initiatePaymentQuery = async (payload) => {
  const res = await api.post(
    endpoints.transactions.query,
    payload
  );

  return res.data;
};